import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  assignedToOrgsLabel: {
    id: 'course-authoring.taxonomy-list.orgs-count.label',
    defaultMessage: 'Assigned to {orgsCount} orgs',
  },
});

export default messages;
